/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './LogoutPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PromotionsCard from 'components/layouts/Promotions/PromotionsCard';
import TestAndTarget from 'components/shared/TestAndTarget/TestAndTarget';
import Alaska529Promo from 'components/pages/Logout/promos/Alaska529Promo';
import Maryland529Promo from 'components/pages/Logout/promos/Maryland529Promo';
import National529Promo from 'components/pages/Logout/promos/National529Promo';
import AllRetailPromo from 'components/pages/Logout/promos/AllRetailPromo';

const PromoMbox = 'ret-aa-new-logout-promo';
const dataAtProperty = 'eb143c91-3999-92fd-60bc-2dca0b84690f';

export const LogoutAdvertising = ({ view }) => {
  const LogoutAd = TestAndTarget(PromotionsCard, PromoMbox, dataAtProperty);
  const { hasAlaska529Only, hasMaryland529Only, hasNational529Only } = view;

  const ProductSpecificAd = () =>
    hasAlaska529Only ? (
      <Alaska529Promo />
    ) : hasMaryland529Only ? (
      <Maryland529Promo />
    ) : hasNational529Only ? (
      <National529Promo />
    ) : (
      <AllRetailPromo />
    );

  return (
    <div className="logout-ad-space">
      <div className="mbox-content">
        <LogoutAd messageName={''} messageText={''} messageId={-1} />
      </div>
      <ProductSpecificAd />
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.accounts
});

export default withRouter(connect(mapStateToProps)(LogoutAdvertising));
